<template>
    <div id="carmodedSearch" class="car-carmoded" :class="showBlock ? 'show-search-block' : ''">
        <div class="vehicle-filter group">
            <div class="row">
                <div class="col make-select-box">
                    <div>Make</div>
                    <div>
                        <select id="make-dropdown" name="VehicleMakeId" v-model="makeId" style="border-radius: 0; font-size: 18px; height: 35px; border: 0; letter-spacing: .8px; border-bottom: 1px solid #8D8D8D; text-transform: uppercase; cursor: pointer; width: 100%; padding: 0 0 8px; transition: all ease .3s;background-color: transparent;margin-top: 10px;">
                            <option value="null">Make</option>
                            <option :value="id" v-for="(make, id) in makes">{{make.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col model-select-box">
                    <div>Model</div>
                    <div>
                        <select id="model-dropdown" name="VehicleModelId" v-model="modelId" style="border-radius: 0; font-size: 18px; height: 35px; border: 0; letter-spacing: .8px; border-bottom: 1px solid #8D8D8D; text-transform: uppercase; cursor: pointer; width: 100%; padding: 0 0 8px; transition: all ease .3s;background-color: transparent;margin-top: 10px;" :disabled="!models">
                            <option value="null">MODEL</option>
                            <option :value="id" v-for="(model, id) in models">{{model.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col year-select-box" v-if="withYears">
                    <div>Year</div>
                    <div>
                        <select id="ModedYearDropDownList" name="VehicleYearId" v-model="yearId" style="border-radius: 0; font-size: 18px; height: 35px; border: 0; letter-spacing: .8px; border-bottom: 1px solid #8D8D8D; text-transform: uppercase; cursor: pointer; width: 100%; padding: 0 0 8px; transition: all ease .3s;background-color: transparent;margin-top: 10px;" :disabled="!years">
                            <option value="null">YEAR</option>
                            <option :value="id" v-for="(year, id) in years">{{year.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col engine-select-box">
                    <div id="enye">Engine</div>
                    <div>
                        <select id="engine-dropdown" name="VehicleEngineId" v-model="engine" style="border-radius: 0; font-size: 18px; height: 35px; border: 0; letter-spacing: .8px; border-bottom: 1px solid #8D8D8D; text-transform: uppercase; cursor: pointer; width: 100%; padding: 0 0 8px; transition: all ease .3s;background-color: transparent;margin-top: 10px;" :disabled="!engines">
                            <option value="null">Engine</option>
                            <option :value="engine.name" v-for="engine in engines">{{engine.name}}</option>
                        </select>
                    </div>
                </div>

                <div class="col ordernowBtn" style="display: flex;align-items: flex-end;">
                    <BuyBtn :product="product" :styles-class="classes" :text="'Order Now'"></BuyBtn>
<!--                    <a href="javascript:createCookie('quickcookie','true',7);submitDoc('addtobasket');" id="modeaddtocart" class="" title="Checkout"> Order Now </a>-->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {bus} from '../../bus'
    export default {
        props: ['product'],
        data() {
            return {
                showBlock: false,
                makes: null,
                makeId: null,
                modelId: null,
                yearId: null,
                engine: null,
                models: null,
                years: null,
                engines: null,
                classes: 'txtButtonAddBasket3 disablecheck',
                withYears: true
            }
        },
        created() {
            this.openListener()
        },
        watch: {
            makeId: function(val) {
                this.years = null
                this.engines = null
                this.modelId = null
                this.yearId = null
                this.engine = null
                if (val) {
                    this.models = this.makes[val].models
                }
            },
            modelId: function(val) {
                this.yearId = null
                this.engine = null
                if (this.withYears) {
                    if (val) {
                        this.years = this.models[val].years
                    }
                } else {
                    if (val) {
                        this.engines = this.models[val].engines
                    }
                }
            },
            yearId: function(val) {
                this.engine = null
                if (val) {
                    this.engines = this.years[val].engines
                }
            },
            engine: function (val) {
                if (val) {
                    this.classes = 'txtButtonAddBasket3'
                    this.product.comment = ''
                    let make = this.makes[this.makeId]
                    let model = make.models[this.modelId]
                    let year = null
                    if (this.withYears) {
                        year = model.years[this.yearId]
                    }
                    this.product.comment += make.name
                    this.product.comment += ' ' + model.name
                    this.product.comment += year ? ' ' + year.name : ''
                    this.product.comment += ' ' + this.engine

                } else {
                    this.classes = 'txtButtonAddBasket3 disablecheck'
                }
            }
        },
        methods: {
            openListener() {
                bus.$on('open-search-wrap', () => {
                    this.showBlock = true
                    this.getData()
                })
            },
            getData() {
                axios.get('/api/vehicle/get-tuning-products/' + this.product.id)
                        .then(res => {
                            this.withYears = res.data.with_years
                            this.makes = res.data.makes
                        })
            }
        }
    }
</script>